const buttonFormMaintenance = {
  cancel: 'CANCELAR MANUTENÇÃO',
  send_to_maintenance: 'ENVIAR PARA MANUTENÇÃO',
  done: 'CONCLUIR MANUTENÇÃO',
  send_back_to_maintenance: 'RETORNAR PARA MANUTENÇÃO'
};

export default buttonFormMaintenance;
